module.exports = {
	/**
	 * @type {string}
	 * @description 首页三张背景图
	 */
	bg1: 'https://fastly.jsdelivr.net/gh/youtatu-hub/photo/blog/img/bg1.jpg',
	bg2: 'https://fastly.jsdelivr.net/gh/youtatu-hub/photo/blog/img/bg2.jpg',
	bg3: 'https://fastly.jsdelivr.net/gh/youtatu-hub/photo/blog/img/bg3.jpg',

	/**
	 * @type {string}
	 * @description 首页故障风文字
	 */
	malfunctionText: 'Youta\'s Blog'
}
